import * as stylex from "@stylexjs/stylex";

// Stable variable names also serve vendor DOM and the Rails pre-paint theme bridge.
// These values are the single source of truth for both themes.
export const colors = {
  "--rel-canvas": "var(--rel-canvas)",
  "--rel-surface": "var(--rel-surface)",
  "--rel-quiet": "var(--rel-quiet)",
  "--rel-raised": "var(--rel-raised)",
  "--rel-highlight": "var(--rel-highlight)",
  "--rel-selection": "var(--rel-selection)",
  "--rel-on-selection": "var(--rel-on-selection)",
  "--rel-media-paper": "var(--rel-media-paper)",
  "--rel-heading": "var(--rel-heading)",
  "--rel-body": "var(--rel-body)",
  "--rel-muted": "var(--rel-muted)",
  "--rel-border": "var(--rel-border)",
  "--rel-control-border": "var(--rel-control-border)",
  "--rel-primary": "var(--rel-primary)",
  "--rel-on-primary": "var(--rel-on-primary)",
  "--rel-primary-hover": "var(--rel-primary-hover)",
  "--rel-primary-pressed": "var(--rel-primary-pressed)",
  "--rel-brand": "var(--rel-brand)",
  "--rel-link": "var(--rel-link)",
  "--rel-link-hover": "var(--rel-link-hover)",
  "--rel-focus": "var(--rel-focus)",
  "--rel-success": "var(--rel-success)",
  "--rel-warning": "var(--rel-warning)",
  "--rel-danger": "var(--rel-danger)",
  "--rel-on-danger": "var(--rel-on-danger)",
  "--rel-info": "var(--rel-info)",
  "--rel-nav": "var(--rel-nav)",
  "--rel-nav-text": "var(--rel-nav-text)",
  "--rel-nav-muted": "var(--rel-nav-muted)",
  "--rel-nav-active": "var(--rel-nav-active)",
  "--rel-nav-accent": "var(--rel-nav-accent)",
  "--rel-nav-border": "var(--rel-nav-border)",
  "--rel-map-ink": "var(--rel-map-ink)",
  "--rel-map-halo": "var(--rel-map-halo)",
  "--rel-chart-1": "var(--rel-chart-1)",
  "--rel-chart-2": "var(--rel-chart-2)",
  "--rel-chart-3": "var(--rel-chart-3)",
  "--rel-chart-4": "var(--rel-chart-4)",
  "--rel-chart-5": "var(--rel-chart-5)",
  "--rel-frame-shadow": "var(--rel-frame-shadow)",
  "--rel-dialog-shadow": "var(--rel-dialog-shadow)",
  "--rel-scrim": "var(--rel-scrim)",
  __varGroupHash__: "xct2909"
};
export const darkTheme = {
  xct2909: "x6b5ilf xct2909",
  $$css: true
};
export const geometry = {
  "--rel-radius-sm": "var(--rel-radius-sm)",
  "--rel-radius-md": "var(--rel-radius-md)",
  "--rel-radius-lg": "var(--rel-radius-lg)",
  "--rel-radius-xl": "var(--rel-radius-xl)",
  "--rel-control-height": "var(--rel-control-height)",
  "--rel-touch-height": "var(--rel-touch-height)",
  "--rel-page-width": "var(--rel-page-width)",
  "--rel-sidebar-width": "var(--rel-sidebar-width)",
  "--rel-sidebar-collapsed-width": "var(--rel-sidebar-collapsed-width)",
  __varGroupHash__: "x1vdkvmf"
};